<template>
  <search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :btnOffset="21"
  :btnSpan="6"
  :inline="true"
  :multipleLines="false"
  >
	<Row class="mb16" :gutter="16">
		<Col span="5">
			<Select v-model="searchData.projectFid" placeholder="项目名称" >
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in projectList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
			</Select>
		</Col>
		<Col span="5">
			<Select v-model="searchData.typeCode" placeholder="类别" >
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in typeList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
			</Select>
		</Col>
		<Col span="5">
			<DatePicker style="width:100%" v-model="searchData.createTime"  split-panels type="daterange" format="yyyy-MM-dd" placeholder="处理日期筛选"></DatePicker>
		</Col>
		<Col span="5">
			<Input type="text" v-model="searchData.dealZoName" placeholder="请搜索处理人"></Input>
		</Col>
	</Row>
	<!-- <Row class="mb16" :gutter="16">

	</Row> -->
	</search-group>
</template>

<script>

// import SearchGroup from 'components/SearchGroup/index';
import {findBusinessScoreList} from 'api/businessDealApi'
import { formatDateTime } from "../../../../../../utils/format";

export default {
	components:{
		// SearchGroup
	},
	props:{
		projectList:{
			type:Array,
			default(){
				return []
			}
		},
		typeList:{
			type:Array,
			default(){
				return []
			}
		}
	},
	data(){
		return{
			searchData:{
				createTime:['','']
			},

		}
	},
	computed:{
		searchParams(){
			function f(data) {
        return data?formatDateTime(data, false):''
			}
			return{
				projectFid:this.searchData.projectFid,
				startDate:f(this.searchData.createTime[0]),
				endDate:f(this.searchData.createTime[1]),
				dealZoName:this.searchData.dealZoName,
				typeCode:this.searchData.typeCode,
			}
		}
	},
	mounted(){
		this.$emit('searchParams',this.searchParams)
	},
	methods:{
		clearValue(){
			this.searchData = {
				projectFid:'',
				createTime:['',''],
				dealZoName:'',
				typeCode:'',
			}
		},
		findData(){
			this.$emit('searchParams',this.searchParams)
		},
	}
}
</script>

<style>

</style>
